/* global $ */

const scrollToEl = {
  methods: {
    scrollToEl(el) {
      if (!el) return;
      const element = el.$el ? el.$el : el;
      if (!element) return;
      try {
        if ($(window).width() <= 787) {
          const desktopHeader = document.querySelector('.header.header-desktop');
          let heightHeader = desktopHeader ? 110 : 100;

          const mobileStoreUpper = document.querySelector('.mobile-store-upper');
          if (mobileStoreUpper) {
            heightHeader += 50;
          }
          const heightScroll = $(element).offset().top - heightHeader;

          window.scrollTo({
            top: heightScroll,
            left: 0,
            behavior: 'smooth',
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};

export default scrollToEl;
